module.exports = __webpack_public_path__ + "logo.827b5281a53ae2bf4b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 1398
// module chunks = 2